<div class="chart-panel-parent">
  <div class="chart-panel-body">
    <div class="global-panel-results">
      <div class="chart-panel-results-table global-panel-results-table"></div>
    </div>
  </div>
</div>